<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <p class="page-title">{{ 'PRIVACY_POLICY_TITLE' | translate }}</p>
            <iframe
                *ngIf="privacyUrl"
                title="{{ 'PRIVACY_POLICY_TITLE' | translate }}"
                class="tnc__iframe"
                [src]="privacyUrl">
            </iframe>
        </div>
    </div>
</div>
